import { Component } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  constructor(public modalRef: MdbModalRef<ModalComponent>, private identityService: IdentityService) { }
  logout() {
    this.identityService.logout(true);
  }
}
